import { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const languages = {
  de: 'Deutsch',
  en: 'English'
};

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    // Check localStorage for saved preference
    const saved = localStorage.getItem('language');
    return saved || 'de';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
    document.documentElement.lang = language;
  }, [language]);

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'de' ? 'en' : 'de');
  };

  const t = (key, translations) => {
    return translations[language] || translations.de || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}

// Common translations used across the site
export const commonTranslations = {
  nav: {
    home: { de: 'Startseite', en: 'Home' },
    about: { de: 'Über Uns', en: 'About Us' },
    companies: { de: 'Unternehmen', en: 'Companies' },
    services: { de: 'Leistungen', en: 'Services' },
    contact: { de: 'Kontakt', en: 'Contact' },
  },
  footer: {
    imprint: { de: 'Impressum', en: 'Imprint' },
    privacy: { de: 'Datenschutz', en: 'Privacy Policy' },
    rights: { de: 'Alle Rechte vorbehalten', en: 'All rights reserved' },
  },
  buttons: {
    learnMore: { de: 'Mehr erfahren', en: 'Learn more' },
    contact: { de: 'Kontakt', en: 'Contact' },
    send: { de: 'Senden', en: 'Send' },
    back: { de: 'Zurück', en: 'Back' },
  },
  form: {
    name: { de: 'Name', en: 'Name' },
    email: { de: 'E-Mail', en: 'Email' },
    phone: { de: 'Telefon', en: 'Phone' },
    message: { de: 'Nachricht', en: 'Message' },
    company: { de: 'Unternehmen', en: 'Company' },
    required: { de: 'Pflichtfeld', en: 'Required' },
  }
};

export default LanguageContext;
